import { ColumnConfig } from '@components/design/migrated/Table';
import { GroupContext } from '@utils/userPreferencesUtils/Types';
import { ItemFeaturesResp, ProductAnalyzerGroupKpi, SaleType } from '@models/Products';
import { ProductsTableGroupRow } from './ProductsTableGroupRow';
import { DisplayOptions } from '../products-table-filter/Types';
import { FocusArea } from '@components/products-top-5-table/Types';
import { GrowthTypes } from '@ecosystem/formatters';

interface Props {
  columns: ColumnConfig[];
  sortedColumn: string;
  context: GroupContext;
  productAnalyzerGroupKpi: ProductAnalyzerGroupKpi[];
  itemFeatures?: ItemFeaturesResp[];
  selectedDisplayType: DisplayOptions;
  selectedSaleType: SaleType;
  selectedFocusArea?: FocusArea;
  currency: string;
  selectedGrowthType: GrowthTypes;
  enableSort?: boolean;
}

export const ProductsTableGroupRows: React.FC<Props> = ({
  columns,
  sortedColumn,
  context,
  productAnalyzerGroupKpi,
  itemFeatures,
  selectedDisplayType,
  selectedSaleType,
  selectedFocusArea,
  currency,
  selectedGrowthType,
  enableSort = true,
}) => {
  return (
    <>
      {productAnalyzerGroupKpi.map(({ groupDetails, groupKpis }) => (
        <ProductsTableGroupRow
          key={groupDetails.groupName}
          groupDetails={groupDetails}
          leaderboardGroupKpi={groupKpis}
          columns={columns}
          sortedColumn={sortedColumn}
          itemFeatures={itemFeatures}
          selectedDisplayType={selectedDisplayType}
          selectedSaleType={selectedSaleType}
          selectedFocusArea={selectedFocusArea}
          currency={currency}
          selectedGrowthType={selectedGrowthType}
          context={context}
          enableSort={enableSort}
        ></ProductsTableGroupRow>
      ))}
    </>
  );
};
